export function getImgSizeByContainerSize(containerSize: number): number {
  let imgSize: number;
  if (containerSize > 1500) {
    // powyżej 1500px – pobieramy 2000px
    imgSize = 2000;
  } else if (containerSize > 1200) {
    // między 1201 a 1500px – pobieramy 1500px
    imgSize = 1500;
  } else if (containerSize > 800) {
    // między 801 a 1200px – pobieramy 1200px
    imgSize = 1200;
  } else if (containerSize > 600) {
    // między 601 a 800px – pobieramy 800px
    imgSize = 800;
  } else if (containerSize > 300) {
    // między 301 a 600px – pobieramy 600px
    imgSize = 600;
  } else {
    // równe lub mniejsze 300px – pobieramy 300px
    imgSize = 300;
  }

  return imgSize;
}
